export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons-react@1.1.2@@ant-design/icons-react/es/index.js
// module id = 252
// module chunks = 0 1